import axios from 'axios';

export default (creds) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .delete(process.env.VUE_APP_API_ADMIN_LOCATION + `vouchers/${creds.id}`)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return promise;
};
